export default "__VITE_PUBLIC_ASSET__62b4979b__"